var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodEveningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dsyx54rxja)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z",
    fill: "#FFE8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.82a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25zM6.788 16.875a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z",
    fill: "#F4DC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.075 22.125a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75zM9 7.945a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM13.875 8.32a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM4.538 11.21a1.5 1.5 0 1 0 0-2.999 1.5 1.5 0 0 0 0 3zM14.625 4.195a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM3.038 15.375a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM19.5 19.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM9.375 12.336a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25zM5.625 6.633a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM17.25 21.227a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "#F4DC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.075 4.048c0 1.05.825 1.875 1.875 1.875s1.875-.825 1.875-1.875S12 2.173 10.95 2.173c-1.05-.037-1.875.825-1.875 1.875z",
    fill: "#F4DC9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dsyx54rxja"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodEveningIcon);
export default __webpack_public_path__ + "static/media/goodEveningIcon.7e3f4739d02bac8f6057ca85e3414c24.svg";
export { ForwardRef as ReactComponent };